/// <amd-module name="VSS/Ext/ExternalContent" />
export * from "./Components/ExternalContent/ExternalContent";
export * from "./Components/ExternalContent/ExternalContentBase";
export {
    ExternalContentResizeOptions,
    IExternalContentInteractionProxy,
    IExternalContentLoadedEvent,
    IExternalContentLoadingErrorEvent,
    IExternalContentResizedEvent,
    IExternalContentInteractionProvider,
    IExternalContentProps,
    IExternalContentBaseProps,
    IExternalContentSharedProps
} from "./Components/ExternalContent/ExternalContent.Props";
export * from "./Components/ExternalContent/SdkInteractionProvider";
